// src/pages/ProductsPage.jsx

import React from 'react';
import { Container, Row, Col, Card, Button, Badge } from 'react-bootstrap';
import products from '../data/productsData';
import './ProductPage.css'

const ProductsPage = () => {
  return (
    <section className="products-page py-5">
      <Container>
        <h2 className="text-center mb-4">Explore Our <span className="text-primary">Products</span></h2>
        <p className="text-center mb-5">
          Discover our innovative solutions designed to address Africa's unique challenges.
        </p>
        <Row>
          {products.map((product, index) => (
            <Col md={6} lg={4} className="mb-4" key={index}>
              <Card className="h-100 shadow-sm">
                <Card.Img variant="top" src={product.logo} alt={`${product.name} logo`} className="p-3" style={{width:"120px",height:"120px"}}/>
                <Card.Body className="modal-content ">
                  <Card.Title>{product.name}</Card.Title>
                  <Card.Text>{product.description}</Card.Text>
                </Card.Body>
                <Card.Footer className="bg-white modal-footer">
                  {product.status === 'live' ? (
                    <Button variant="secondary" href={product.url} target="_blank" rel="noopener noreferrer">
                      Visit Website
                    </Button>
                  ) : (
                    <>
                      <Badge bg="warning" text="dark" className="me-2">Coming Soon</Badge>
                      {/*<Button variant="outline-secondary" disabled>
                        Notify Me
                      </Button>*/}
                    </>
                  )}
                </Card.Footer>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default ProductsPage;
